import { mapImageFields } from '@/adapters/common'
import { IMassMediaPost, IMassMediaPostCategory } from '@/interfaces/media'
import { defaultLocaleFull } from '@/shared/utils/directus'

export function mapMassMediaPostFields(item: Directus.MassMediaPost, locale: string): IMassMediaPost | null {
  const { url, url_en, date_published, translations, image_preview, image_preview_en } = item

  const actualUrl = locale === defaultLocaleFull ? url : url_en || url

  if (!actualUrl) {
    return null
  }

  if (!translations?.[0]?.title) {
    return null
  }

  const actualImagePreview = locale === defaultLocaleFull ? image_preview : image_preview_en || image_preview

  return {
    url: actualUrl,
    date_published: date_published,
    title: translations[0].title,
    excerpt: translations[0].excerpt,
    source: translations[0].source,
    image_preview: mapImageFields(actualImagePreview),
  }
}

export function mapMassMediaPostCategoryFields(item: Directus.MassMediaPostCategory): IMassMediaPostCategory | null {
  if (!item.slug || !item.translations?.[0]?.name) {
    return null
  }

  return {
    slug: item.slug,
    name: item.translations[0].name,
  }
}
